import { I18nEntryArray } from '@monorepo/types';
import { useQuery } from '@tanstack/react-query';
import { fetchMenuTranslations } from '../../utils/react-query/query-functions';
import { QUERY_KEYS } from '../../utils/react-query/query-keys';
import { ExtractFnReturnType } from '../../utils/react-query/react-query';

export const useMenuTranslationsQuery = () => {
  return useQuery<
    ExtractFnReturnType<typeof fetchMenuTranslations>,
    Error,
    I18nEntryArray
  >({
    queryKey: QUERY_KEYS.APP_CONFIG.MENU_TRANSLATIONS,
    queryFn: fetchMenuTranslations,
    staleTime: 60 * 60 * 1000,
    refetchInterval: 60 * 60 * 1000,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    // enabled: i18nextLng !== 'en', TODO: Enable this when we have the PR closed of TT5ERS-5520 and we have a way to detect language changes from path params
  });
};
